import { SelectCard, TopButtons } from "./../../components/index";
import locksIcon from "./../../assets/svg/locks.svg";
import peripheralsIcon from "./../../assets/svg/peripherals.svg";
import { useBreadcrumb } from "../../hooks/useBreadcrumb";

export default function Firmware() {
  useBreadcrumb([{ label: "Home", path: "/" }, { label: "Firmware" }]);

  return (
    <div className="firmware">
      <TopButtons />
      <h2>Select an Option</h2>
      <div className="cards">
        <SelectCard
          img={locksIcon}
          title="Access Point"
          url="/firmware/locks"
        />
        <SelectCard
          img={peripheralsIcon}
          title="Peripheral"
          url="/firmware/peripherals"
        />
      </div>
    </div>
  );
}
